<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>

<ng-container *ngIf="programInfo$ | async as programInfo">
  <app-brand-header [brandColor]="programInfo.color" [brandLogoUrl]="programInfo.logo" [brandSlug]="programInfo.company_slug"></app-brand-header>

  <div class="top-banner" [style.backgroundImage]="'url(' + programInfo.picture_cover + ')'"></div>

  <div class="container-xl" [style]="{'--color': programInfo.color}">
    <h1 [style.color]="programInfo.color">{{programInfo.title[currentLanguage]}}</h1>
    <h2 [style.color]="programInfo.color">{{programInfo.subtitle[currentLanguage]}}</h2>
    <div class="description" [innerHTML]="programInfo.description[currentLanguage]"></div>
    <div id="target" #target></div>

    <div class="projects-container" [style.backgroundColor]="getRGBAColor(0.1)">
      <div class="noos-logo" [innerHTML]="getSvgNoosLogo()"></div>
      <div class="stepper-wrapper" *ngIf="!programInfo.hide_button">
        <div class="step" [class.active]="step === 1" [class.past]="step >= 2">1</div>
        <div class="step" [class.active]="step === 2" [class.past]="step === 3">2</div>
        <div class="step" [class.active]="step === 3">3</div>
      </div>
      <ng-template [ngIf]="step === 1">
        <div class="projects-container-heading">
          {{ "BRAND_PAGE.text1_brand_page" | translate }}
        </div>
        <div class="projects-container-subheading" [style.color]="programInfo.color">
          {{ programInfo.company_name }} {{ "BRAND_PAGE.text3_brand_page" | translate }}</div>
        <div class="project-wrapper" *ngFor="let project of programInfo.projects">
          <div class="project-image clickable"
            [style.backgroundImage]="'url(' + project.picture_thumbnail + ')'"
            (click)="redirectToProject(project.slug)"
            *ngIf="programInfo.clickable_images"></div>
          <div class="project-image"
            [style.backgroundImage]="'url(' + project.picture_thumbnail + ')'"
            *ngIf="!programInfo.clickable_images"></div>
          <div class="project-info">
            <div *ngIf="project.continent !== 'worldwide' && screenWidth > 991"
                 class="location">{{ "PREFERENCES_POPUP_2." + project.continent + "_preferencespopup2" | translate }}
              - {{"COUNTRIES." + project.country | translate}}</div>
            <div *ngIf="project.continent === 'worldwide' && screenWidth > 991"
                 class="location">{{ "PREFERENCES_POPUP_2.worldwide_preferencespopup2" | translate }}</div>
            <div class="project-heading">{{project.title[currentLanguage]}}</div>
            <div
              class="project-subheading">{{ "BRAND_PAGE.by_brand_page" | translate }} {{ project.organization }}</div>
            <div *ngIf="project.continent !== 'worldwide' && screenWidth <= 991"
                 class="location">{{ "PREFERENCES_POPUP_2." + project.continent + "_preferencespopup2" | translate }}
              - {{"COUNTRIES." + project.country | translate}}</div>
            <div *ngIf="project.continent === 'worldwide' && screenWidth <= 991"
                 class="location">{{ "PREFERENCES_POPUP_2.worldwide_preferencespopup2" | translate }}</div>
            <div [innerHTML]="project.short_description[currentLanguage]"
                 [ngStyle]="project.read_more_clicked ? {} : getTruncatedStyle(project.short_description)"
                 class="project-desc ns-line-height-24 ns-dark-blue"></div>
            <div (click)="toggleReadMore(project.project_id)" class="read-more">
              {{ project.read_more_clicked ? ("LAC.read_less" | translate) : ("LAC.read_more" | translate) }}
            </div>
            <button
              class="project-action-button yellow sans-serif"
              (click)="chooseProject(project, target)"
              *ngIf="!programInfo.hide_button">
              <span class="flash"><img alt="flash" loading="lazy" src="/assets/icons/flash.svg"></span>
              {{ "BRAND_PAGE.cta2_brand_page" | translate }}
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="step === 2">
        <div (click)="returnToFirstStep(target)"
             class="return-button">{{ "BRAND_PAGE.back_brand_page" | translate }}</div>
        <div class="projects-container-heading">{{ "BRAND_PAGE.text4_brand_page"| translate }}</div>
        <div
          class="projects-container-subheading">{{"BRAND_PAGE.customers_pledge_confirmation_title" | translate }}</div>
        <p>{{ "BRAND_PAGE.customers_pledge_confirmation_text" | translate }}</p>
        <form class="d-flex flex-column align-items-center" (ngSubmit)="validateImpact()" [formGroup]="form">
          <label>
            <span class="label">{{ "BRAND_PAGE.text11_brand_page" | translate }}
              <span> *</span></span>
            <input (blur)="onFocusLost('email')" [ngClass]="{'input-error': touchedAndInvalid('email') }"
                   formControlName="email"
                   type="email">
          </label> <label style="position: relative;">
          <span class="label">{{ "BRAND_PAGE.text11_confirm_brand_page" | translate }}
            <span> *</span></span>
          <input (blur)="onFocusLost('confirmEmail')" [ngClass]="{'input-error': touchedAndInvalid('confirmEmail') }"
                 appNoCopyPaste
                 formControlName="confirmEmail" type="email">
          <div *ngIf="showErrors" class="error-message">
            {{ errorMessage | translate }}
          </div>
        </label>
          <input #agreement
                 (change)="termsCheckedControl.setValue(agreement.checked);onFocusLost('termsChecked');"
                 formControlName="termsChecked" id="agreement" type="checkbox">
          <label [ngClass]="{'input-error': touchedAndInvalid('termsChecked') }" for="agreement">
            {{ "BRAND_PAGE.read_brand_page" | translate }}
            <a
              [routerLink]="[currentLang, RouterUrls.TermsOfService]"
              target="_blank">{{ "SIGN_UP_PAGE.terms_of_service_signup" | translate }}</a>
            {{ "BRAND_PAGE.read_brand_page_2" | translate }}
          </label>

          <button type="submit" class="confirm-button" [disabled]="disabledButton">
            {{ "BRAND_PAGE.text12_brand_page" | translate }}
            <span><img src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow" loading="lazy"></span>
          </button>
        </form>
      </ng-template>

      <ng-template [ngIf]="step === 3 && status === 0">
        <div class="projects-container-heading">{{ "BRAND_PAGE.thank_brand_page" | translate }}</div>
        <div [style.color]="programInfo.color" class="projects-container-subheading">{{ programInfo.company_name
          }} {{ "BRAND_PAGE.text13_brand_page" | translate }}</div>
        <p style="font-weight: normal;margin-bottom:-22px;">
          {{ "BRAND_PAGE.text14_brand_page" | translate }} {{ programInfo.natural_end_date[currentLanguage] }}
          . {{ "BRAND_PAGE.text15_brand_page" | translate }} {{ programInfo.company_name }}.
        </p>
        <br><br>
        <p *ngIf="!programInfo.company_is_lac_only">
          <b>{{ "BRAND_PAGE.text16_brand_page" | translate }}</b>
        </p>
        <div class="buttons-wrapper" *ngIf="!programInfo.company_is_lac_only">
          <div (click)="redirectToProject(chosenProject.slug)" class="final-button final-button-1" tabindex="0">
            <span>{{ "BRAND_PAGE.text17_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
          <div (click)="redirectToProjects()" class="final-button final-button-2" tabindex="0">
            <span>{{ "BRAND_PAGE.text18_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="step === 3 && status === 1">
        <div class="projects-container-heading">{{ "BRAND_PAGE.text19_brand_page" | translate }}</div>
        <div class="projects-container-subheading" [style.color]="programInfo.color">{{ programInfo.company_name }} {{ "BRAND_PAGE.text20_brand_page" | translate }} {{ programInfo.premium_factor }}</div>
        <p>
          {{ "BRAND_PAGE.text21_brand_page" | translate }} {{ "BRAND_PAGE.text14_brand_page" | translate }} {{ programInfo.natural_end_date[currentLanguage] }}. {{ "BRAND_PAGE.text15_brand_page" | translate }} {{ programInfo.company_name }}.
          <br><br>
          <b *ngIf="!programInfo.company_is_lac_only">{{ "BRAND_PAGE.text16_brand_page" | translate }}</b>
        </p>
        <div class="buttons-wrapper" *ngIf="!programInfo.company_is_lac_only">
          <div (click)="redirectToProject(chosenProject.slug)" class="final-button final-button-1" tabindex="0">
            <span>{{ "BRAND_PAGE.text17_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
          <div (click)="redirectToProjects()" class="final-button final-button-2" tabindex="0">
            <span>{{ "BRAND_PAGE.text18_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="step === 3 && status === 2">
        <div class="projects-container-heading">{{ "BRAND_PAGE.text22_brand_page" | translate }}</div>
        <div class="projects-container-subheading" [style.color]="programInfo.color">{{ "BRAND_PAGE.text23_brand_page" | translate }} {{ programInfo.company_name }}</div>
        <p *ngIf="!programInfo.company_is_lac_only">
          <b>{{ "BRAND_PAGE.text24_brand_page" | translate }}</b>
        </p>
        <div class="buttons-wrapper" *ngIf="!programInfo.company_is_lac_only">
          <div (click)="redirectToProject(chosenProject.slug)" class="final-button final-button-1" tabindex="0">
            <span>{{ "BRAND_PAGE.text25_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
          <div (click)="redirectToProjects()" class="final-button final-button-2" tabindex="0">
            <span>{{ "BRAND_PAGE.text18_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
        </div>
      </ng-template>
      <!-- Oups page - Already voted page -->
      <ng-template [ngIf]="step === 3 && status === 3">
        <div class="return-button" (click)="returnToFirstStep(target)">{{ "BRAND_PAGE.back_brand_page" | translate }}</div>
        <div class="projects-container-heading">{{ "BRAND_PAGE.text22_brand_page" | translate }}</div>
        <div [style.color]="programInfo.color" class="projects-container-subheading">{{ "BRAND_PAGE.text26_brand_page" | translate }}</div>
        <p *ngIf="!programInfo.company_is_lac_only">
          <b>{{ "BRAND_PAGE.text24_brand_page" | translate }}</b>
        </p>
        <div class="buttons-wrapper" *ngIf="!programInfo.company_is_lac_only">
          <div (click)="redirectToProject(chosenProject.slug)" class="final-button final-button-1" tabindex="0">
            <span>{{ "BRAND_PAGE.text25_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
          <div (click)="redirectToProjects()" class="final-button final-button-2" tabindex="0">
            <span>{{ "BRAND_PAGE.text18_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
        </div>
      </ng-template>
<!-- Thank you page -->
      <ng-template [ngIf]="step === 3 && status === 4">
        <div class="projects-container-heading">{{ "BRAND_PAGE.text27_brand_page" | translate }}</div>
        <div class="projects-container-subheading" [style.color]="programInfo.color">{{ "BRAND_PAGE.text28_brand_page" | translate }}</div>
        <p *ngIf="!programInfo.company_is_lac_only">
          <b>{{ "BRAND_PAGE.text24_brand_page" | translate }}</b>
        </p>
        <div class="buttons-wrapper" *ngIf="!programInfo.company_is_lac_only">
          <div (click)="redirectToProject(chosenProject.slug)" class="final-button final-button-1" tabindex="0">
            <span>{{ "BRAND_PAGE.text25_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
          <div (click)="redirectToProjects()" class="final-button final-button-2" tabindex="0">
            <span>{{ "BRAND_PAGE.text18_brand_page" | translate }}</span>
            <img loading="lazy" src="/assets/icons/arrow-right-very-dark-blue.svg" alt="arrow">
          </div>
        </div>
      </ng-template>

    </div>
  </div>

  <app-brand-footer [brandColor]="programInfo.color"></app-brand-footer>

</ng-container>
